export const countryCodeList = ['US', 'CA', 'GB'];